import moment from 'moment'

export const minimumAge = (date, age) => {
  const typedAge = +age
  return moment(date, 'DD.MM.YYYY').isBefore(moment().subtract(typedAge, 'years'))
}

export const maximumAge = (date, age) => {
  const typedAge = +age
  return moment(date, 'DD.MM.YYYY').isAfter(moment().subtract(typedAge, 'years'))
}

export const password = (value) => {
  if (value.length < 12) {
    return false
  }

  if (!value.match(/[a-zöäü]/)) {
    return false
  }

  if (!value.match(/[A-ZÜÖÄ]/)) {
    return false
  }

  if (!value.match(/[0-9]/)) {
    return false
  }

  if (!value.match(/[^A-ZÜÖÄ0-9]/)) {
    return false
  }

  return true
}

export const serialNumber = (dottedSerialNumber) => {
  const splitSerialNumber = dottedSerialNumber.split('.').join('')
  let serialNumberSum = 0
  const faktor = '32765432'

  for (let count = 0; count < 8; count++) { // eslint-disable-line no-plusplus
    serialNumberSum += splitSerialNumber[count] * faktor[count]
  }

  return (serialNumberSum % 11) % 10 === ~~splitSerialNumber[8]
}

export const driverUnderTwentyfive = (youngDriverOption, driverAge, customerType) => !(youngDriverOption === 'no' && (driverAge < 25 && customerType === 'person'))

export const looksLikeAnInteger = (value) => `${value}` === '0' || !!`${value}`.match(/^[1-9]\d*$/)

export default {
  minimumAge,
  maximumAge,
  password,
  serialNumber,
  driverUnderTwentyfive,
  looksLikeAnInteger,
}
